import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonFunctions } from '../../common-functions';
declare var dataLayer;
@Component({
  selector: 'app-payment-status-dialog',
  templateUrl: './payment-status-dialog.component.html',
  styleUrls: ['./payment-status-dialog.component.scss']
})
export class PaymentStatusDialogComponent{
  public reloadPay:boolean = false;
  userType: any;
  userId: any;
  tierType: any;
  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<PaymentStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonFunction: CommonFunctions
  ) {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  continue() {
    this.dialogRef.close();
    if(sessionStorage.getItem('reloadCardPay') == 'true'){
      this.reloadPay = true;
    }
    if (this.data == 'cart') {
      this.router.navigate(['/cart']);
    } else if (this.data == 'giftcards') {
      this.router.navigate(['/giftcards']);
    } else if (this.data == 'pay' && this.reloadPay == false) {
      this.router.navigate(['/pay']);
    } else if(this.data == 'pay' && this.reloadPay == true){
      this.router.navigate(['/cart']);
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}
